import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">
            Политика конфиденциальности
          </Link>
          <span className="footer-separator">•</span>
          <Link to="/terms" className="footer-link">
            Пользовательское соглашение
          </Link>
        </div>
        <div className="footer-copyright">
          © 2025 Telegram Stars. Все права защищены.
        </div>
      </div>
    </footer>
  );
}

export default Footer;

